import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import InputBase from '@material-ui/core/InputBase';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';

import useTopBarStyles from './useTopBarStyles';

const TopBar= (props) => {
    const classes = useTopBarStyles();
    return (
        <AppBar position="fixed" className={classes.appBar}>
            <Toolbar 
                className={classes.toolbar}>
                <IconButton 
                    className={classes.menuButton}
                    edge="start" 
                    aria-label="Open Drawer"
                    color="inherit" 
                    onClick={props.onToggleMenu}>
                        <MenuIcon />
                </IconButton>
                <div className={classes.searchBar}>
                    <div className={classes.searchIcon}>
                        <SearchIcon />
                    </div>
                    <InputBase 
                        classes={{
                            root: classes.inputBaseRoot,
                            input: classes.inputBaseInput
                        }}
                        placeholder="StopId"
                    />
                </div>
            </Toolbar>
        </AppBar>
    );
};

export default TopBar;